import {pageInitializationActionTypes} from './../consts';

const actionTypes = Object.keys(pageInitializationActionTypes);

const pageInitializationStatus = (state = pageInitializationActionTypes.PAGE_INITIALIZATION_START, action) => {
    if (actionTypes.includes(action.type)) {
        return pageInitializationActionTypes[action.type];
    }
    return state;
};

export default pageInitializationStatus;


// WEBPACK FOOTER //
// ./src/app/reducers/pageInitializationStatus.js